import React, { useState, useEffect, useRef } from 'react';
import { Button, Badge, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";
import $ from "jquery";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const View_Cat_Packing = () => {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sno = queryParams.get('data');
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [items, setItems] = useState([]);
  const [addons, setAddons] = useState([]);
  const [order, setOrder] = useState(null);

  // Fetch order data
  useEffect(() => {
    const fetchOrder = async () => {
      if (!sno) return;

      try {
        const res = await axios.get(`${BaseUrl}/corp-packing-item-view/${sno}`, {
          params: { branch_id }
        });

        if (!res.data?.data) {
          toast.info("Order not found");
          setOrder(null);
          setItems([]);
          setAddons([]);
          return;
        }

        const orderData = res.data.data;
        setOrder(orderData);
        setItems(orderData.item_list || []);
        setAddons(orderData.addons_list || []);
      } catch (err) {
        console.error("Failed to fetch order details:", err);
        toast.error("Failed to fetch order details");
      }
    };
    fetchOrder();
  }, [sno, branch_id, BaseUrl]);

  const getMeasurementUnit = (item) => {
    switch (item.measurement_quantity) {
      case 1:
      case 2: return "kgs";
      case 3:
      case 4: return "ltrs";
      case 5: return "no's";
      default: return "Units";
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const tableRef = useRef(null);
  useEffect(() => {
    if (tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          "responsive": true,
          //   "aaSorting": [],
          "ordering": false,
          "paging": false,
          "language": {
            "lengthMenu": "Show _MENU_",
          },
          "dom":
            "<'row'" +
            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
            // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
            ">"
        });
      }
    }
  }, []);


  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
        <div className='mb-0'>
          <div className="mb-0 px-0">
            <h4 className='breadcrumb-header'>View Corporate Packing</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Production Management</li>
            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Manage Packing</li>
          </ol>
        </div>

      </div>

      <div className='row mb-2'>
        <div className="col-lg-3 col-md-4 col-sm-2 mb-2 px-4 py-4 mx-4" style={{ borderRight: '1px solid #bebebeff' }}>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Customer Name</label>
              <label className='text-primary fs-6 font-w600'>{order?.customer_name ?? ""}</label>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Customer Mobile No</label>
              <label className='text-primary fs-6 font-w600'>{order?.customer_number ?? ""}</label>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Order Id</label>
              <label className='text-primary fs-6 font-w600'>{order?.order_id ?? ""}</label>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Delivery Date</label>
              <label className='text-primary fs-6 font-w600'>{order ? formatDate(order.packing_date) : ""}</label>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Delivery Address</label>
              <label className='text-primary fs-6 font-w600'>{order?.delivery_address ?? ""}</label>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Total Items</label>
              <Badge bg="primary" className='text-white fs-6 px-3 py-0'>
                {(() => {
                  try {
                    const itemsArray = JSON.parse(order?.item_list ?? '[]');
                    return itemsArray.length;
                  } catch {
                    return 0;
                  }
                })()}
              </Badge>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-start mb-3'>
              <label className='text-black font-w600 fs-7'>Total Add-On's</label>
              <Badge bg="primary" className='text-white fs-6 px-3 py-0'>
                {(() => {
                  try {
                    const addonArray = JSON.parse(order?.addons_list ?? '[]');
                    return addonArray.length;
                  } catch {
                    return 0;
                  }
                })()}
              </Badge>
            </div>
          </div>
        </div>

        {/* Items & Add-Ons */}
        <div className='col-lg-8 mb-2'>
          <div className='row'>
            {/* Items Table */}
            <div className='col-12 mb-2'>
              <label className='text-red font-w600 fs-4 mb-2'>Items Packing</label>
              <div className="scroll-y" style={{ maxHeight: "400px", overflowY: "auto" }}>
                {Array.isArray(items) && items.length > 0 ? (
                  <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                    style={{ borderBottom: '2px solid #ddd' }}>
                    <thead>
                      <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                        <th>Packed</th>
                        <th>Item</th>
                        <th className="text-center">Total Qty</th>
                      </tr>
                    </thead>

                    <tbody>
                      {items.map(item => (
                        <tr key={item.id}>
                          <td>
                            <div className="form-check custom-checkbox">
                              <input
                                type="checkbox"
                                className="form-check-input me-3"
                                id={`customCheckBox${item.id}`}
                                checked={item.item_list_status !== 0}
                                disabled
                              />
                            </div>
                          </td>

                          <td className='text-black'>{item.item_name}</td>

                          <td className="text-center text-black">
                            {item.quantity} {getMeasurementUnit(item)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No items found.</p>
                )}
              </div>
            </div>

            {items.some(row => row.vessels_list?.length > 0) && (
              <div className='col-12 mb-2'>
                <h5 className="text-black font-w600 mb-3 fs-4">Selected Vessels</h5>

                <div className="p-4 rounded"
                  style={{ backgroundColor: '#f0f5ef', maxHeight: '300px', overflowY: 'auto' }}>

                  {items.map(row =>
                    row.vessels_list?.length > 0 && (
                      <div key={row.id} className="mb-2">
                        <h5 className="text-black font-w600 mb-3 fs-4">
                          {row.item_name} - Selected Vessels
                        </h5>

                        <div className="d-flex flex-wrap gap-2" style={{ rowGap: "15px" }}>
                          {row.vessels_list.map((v, idx) => (
                            <div key={idx}
                              className="p-3 rounded shadow-sm bg-white"
                              style={{ width: "calc(25% - 10px)", border: "1px solid #e0e0e0" }}>

                              <div className="fw-bold text-black fs-6">
                                {v?.name ?? "-"}
                              </div>

                              <div className="fs-6 text-black mt-1">
                                {v.count} No's
                              </div>

                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

            {/* Add-Ons Table */}
            {addons.length > 0 && (
              <div className='col-12 mb-2'>
                <label className='text-red font-w600 fs-4 mb-2'>Add-On's Checklist</label>
                <div className="scroll-y" style={{ maxHeight: "300px" }}>
                  {addons.length ? (
                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                      <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                          <th>Selected</th>
                          <th>Add-On's</th>
                          <th className="text-center">Total Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {addons.map(addon => (
                          <tr key={addon.id}>
                            <td>
                              <div className="form-check custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="form-check-input me-3"
                                  id={`customCheckBox${addon.id}`}
                                  checked={addon.status !== 0}
                                  disabled
                                />
                              </div>
                            </td>
                            <td className='text-black'>{addon.service_name}</td>
                            <td className="text-center text-black">{addon.quantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : <p>No add-on services found.</p>}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  )


}
export default View_Cat_Packing;